import { form } from '../components/forms/form';

export default class Contact {
  constructor() {
    // Recaptcha submit handler for each form
    form('#form-contact');
  }
}
